(() => {
 if (window.llReviewMediaReady) return;
 window.llReviewMediaReady = true;
 const script = document.currentScript;
 const labels = {title:script?.dataset.reviewTitle || 'Customer review media',close:script?.dataset.reviewClose || 'Close enlarged review media'};
 let dialog, body, closer, origin;
 const clear = () => {
  body?.querySelectorAll('video').forEach(video => { video.pause(); video.removeAttribute('src'); video.load(); });
  body?.querySelectorAll('.ll-review-media-frame').forEach(frame => frame.llReviewDispose?.());
  body?.replaceChildren();
 };
 const close = () => { if (dialog?.open) dialog.close(); };
 const create = () => {
  const style = document.createElement('style');
  style.textContent = '.ll-review-media-dialog{position:fixed;inset:0;margin:0;width:100vw;height:100dvh;max-width:none;max-height:none;padding:0;border:0;border-radius:0;background:transparent;color:#fff;overflow:hidden}.ll-review-media-dialog::backdrop{background:rgba(15,12,9,.88)}.ll-review-media-close{position:fixed;top:max(12px,env(safe-area-inset-top));right:max(12px,env(safe-area-inset-right));z-index:3;display:grid;place-items:center;width:44px;height:44px;padding:11px;cursor:pointer;border:0;border-radius:50%;background:rgba(20,15,11,.62);color:#fff}.ll-review-media-close:focus-visible{outline:2px solid #fff;outline-offset:3px}.ll-review-media-body{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;overflow:hidden}.ll-review-media-frame{position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:100%;overflow:hidden;touch-action:none;cursor:zoom-in;outline:0}.ll-review-media-frame.is-zoomed{cursor:grab}.ll-review-media-frame.is-panning{cursor:grabbing}.ll-review-media-frame:focus-visible{box-shadow:inset 0 0 0 2px #fff9}.ll-review-media-body img{display:block;flex:none;width:auto;height:auto;max-width:calc(100vw - 28px);max-height:calc(100dvh - 28px);object-fit:contain;transform-origin:center;user-select:none;will-change:transform}.ll-review-media-body video{display:block;width:calc(100vw - 32px);height:calc(100dvh - 32px);max-width:none;max-height:none;object-fit:contain}.ll-review-media-hint{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}';
  document.head.append(style);
  dialog = document.createElement('dialog');
  dialog.className = 'll-review-media-dialog';
  dialog.setAttribute('aria-label', labels.title);
  closer = document.createElement('button');
  closer.type = 'button';
  closer.className = 'll-review-media-close';
  closer.setAttribute('aria-label', labels.close);
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', '22');
  svg.setAttribute('height', '22');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '1.8');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', 'M6 6l12 12M18 6 6 18');
  svg.append(path);
  closer.append(svg);
  body = document.createElement('div');
  body.className = 'll-review-media-body';
  dialog.append(body, closer);
  document.body.append(dialog);
  closer.addEventListener('click', close);
  dialog.addEventListener('keydown', event => { if (event.key === 'Escape') event.stopPropagation(); });
  dialog.addEventListener('close', () => {
   clear();
   if (origin?.isConnected) origin.focus({preventScroll:true});
  });
 };
 const imageFrame = (image, hintText, rotation = 0) => {
  const quarterTurn = rotation === 90 || rotation === 270;
  if (quarterTurn) {
   image.style.maxWidth = 'calc(100dvh - 28px)';
   image.style.maxHeight = 'calc(100vw - 28px)';
  }
  image.style.transform = 'rotate(' + rotation + 'deg)';
  const frame = document.createElement('div');
  frame.className = 'll-review-media-frame';
  frame.tabIndex = 0;
  frame.setAttribute('role', 'button');
  frame.setAttribute('aria-label', image.alt);
  frame.setAttribute('aria-describedby', 'll-review-media-hint');
  const hint = document.createElement('span');
  hint.id = 'll-review-media-hint';
  hint.className = 'll-review-media-hint';
  hint.textContent = hintText;
  frame.append(image, hint);
  let scale = 1, x = 0, y = 0, cropX = 0, base, moved = false, suppressClick = false, queued = 0;
  const pointers = new Map();
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const paint = () => {
   queued = 0;
   const fittedWidth = quarterTurn ? image.offsetHeight : image.offsetWidth * (1 - 2 * cropX);
   const fittedHeight = quarterTurn ? image.offsetWidth * (1 - 2 * cropX) : image.offsetHeight;
   const maxX = Math.max(0, (fittedWidth * scale - frame.clientWidth) / 2);
   const maxY = Math.max(0, (fittedHeight * scale - frame.clientHeight) / 2);
   x = clamp(x, -maxX, maxX);
   y = clamp(y, -maxY, maxY);
   image.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + rotation + 'deg) scale(' + scale + ')';
   frame.classList.toggle('is-zoomed', scale > 1.01);
  };
  const schedule = () => { if (!queued) queued = requestAnimationFrame(paint); };
  const point = (clientX, clientY) => {
   const rect = frame.getBoundingClientRect();
   return {x:clientX - rect.left - rect.width / 2,y:clientY - rect.top - rect.height / 2};
  };
  const zoom = (next, anchor = {x:0,y:0}) => {
   next = clamp(next, 1, 6);
   const ratio = next / scale;
   x = anchor.x - (anchor.x - x) * ratio;
   y = anchor.y - (anchor.y - y) * ratio;
   scale = next;
   schedule();
  };
  const captureBase = () => {
   const values = [...pointers.values()];
   const a = values[0], b = values[1];
   base = {scale,x,y,first:a,center:b?{x:(a.x+b.x)/2,y:(a.y+b.y)/2}:a,distance:b?Math.hypot(a.x-b.x,a.y-b.y):0};
  };
  frame.addEventListener('wheel', event => {
   event.preventDefault();
   zoom(scale * Math.exp(-event.deltaY * .002), point(event.clientX, event.clientY));
  }, {passive:false});
  frame.addEventListener('pointerdown', event => {
   if (event.pointerType === 'mouse' && event.button !== 0) return;
   pointers.set(event.pointerId, point(event.clientX, event.clientY));
   frame.setPointerCapture(event.pointerId);
   moved = false;
   captureBase();
  });
  frame.addEventListener('pointermove', event => {
   if (!pointers.has(event.pointerId) || !base) return;
   const current = point(event.clientX, event.clientY);
   pointers.set(event.pointerId, current);
   const values = [...pointers.values()], a = values[0], b = values[1];
   if (b && base.distance) {
    const center = {x:(a.x+b.x)/2,y:(a.y+b.y)/2};
    scale = clamp(base.scale * Math.hypot(a.x-b.x,a.y-b.y) / base.distance, 1, 6);
    const ratio = scale / base.scale;
    x = center.x - (base.center.x - base.x) * ratio;
    y = center.y - (base.center.y - base.y) * ratio;
    moved = true;
   } else if (scale > 1) {
    x = base.x + current.x - base.first.x;
    y = base.y + current.y - base.first.y;
    if (Math.hypot(current.x-base.first.x,current.y-base.first.y) > 4) moved = true;
   }
   if (moved) { event.preventDefault(); frame.classList.add('is-panning'); schedule(); }
  });
  const release = event => {
   if (!pointers.has(event.pointerId)) return;
   pointers.delete(event.pointerId);
   suppressClick = moved;
   frame.classList.remove('is-panning');
   if (pointers.size) captureBase(); else base = null;
   window.setTimeout(() => { suppressClick = false; }, 0);
  };
  frame.addEventListener('pointerup', release);
  frame.addEventListener('pointercancel', release);
  frame.addEventListener('click', event => {
   if (suppressClick || moved) return;
   const rect = image.getBoundingClientRect();
   const insetX = quarterTurn ? 0 : rect.width * cropX, insetY = quarterTurn ? rect.height * cropX : 0;
   if (event.clientX < rect.left + insetX || event.clientX > rect.right - insetX || event.clientY < rect.top + insetY || event.clientY > rect.bottom - insetY) { close(); return; }
   zoom(scale > 1 ? 1 : 2.5, point(event.clientX, event.clientY));
  });
  frame.addEventListener('keydown', event => {
   if (['Enter',' ','+','=','-','_','0','ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) {
    event.preventDefault();
    if (event.key === 'Enter' || event.key === ' ') zoom(scale > 1 ? 1 : 2.5);
    else if (event.key === '+' || event.key === '=') zoom(scale * 1.25);
    else if (event.key === '-' || event.key === '_') zoom(scale / 1.25);
    else if (event.key === '0') zoom(1);
    else { const step = 50; if (event.key === 'ArrowLeft') x += step; if (event.key === 'ArrowRight') x -= step; if (event.key === 'ArrowUp') y += step; if (event.key === 'ArrowDown') y -= step; schedule(); }
   }
  });
  const fit = () => {
   if (!image.naturalWidth || !image.naturalHeight || !frame.clientWidth || !frame.clientHeight) return;
   const availableWidth=Math.max(1,frame.clientWidth-32),availableHeight=Math.max(1,frame.clientHeight-32);
   cropX = ['https://assets.wfcdn.com/im/42101880/resize-h1200-w1200%5Ecompr-r85/4977/497780758/default_name.jpg','https://assets.wfcdn.com/im/77857599/resize-h1200-w1200%5Ecompr-r85/4081/408151698/default_name.jpg'].includes(image.currentSrc || image.src) ? .125 : 0;
   image.style.clipPath = cropX ? 'inset(0 ' + (cropX * 100) + '%)' : '';
   const visibleWidth = image.naturalWidth * (1 - 2 * cropX);
   const ratio=Math.min(availableWidth/(quarterTurn?image.naturalHeight:visibleWidth),availableHeight/(quarterTurn?visibleWidth:image.naturalHeight));
   image.style.maxWidth='none';image.style.maxHeight='none';image.style.width=image.naturalWidth*ratio+'px';image.style.height=image.naturalHeight*ratio+'px';schedule();
  };
  const observer=new ResizeObserver(fit);observer.observe(frame);image.addEventListener('load',fit);
  frame.llReviewDispose=()=>{observer.disconnect();image.removeEventListener('load',fit);cancelAnimationFrame(queued);};
  return frame;
 };
 document.addEventListener('dragstart', event => {
  if (event.target.closest('.ll-review-photo-grid,.ll-feedback-photos')) event.preventDefault();
 }, true);
 let galleryDrag;
 document.addEventListener('pointerdown', event => {
  if (event.pointerType !== 'mouse' || event.button !== 0) return;
  const gallery = event.target.closest('.ll-review-photo-grid,.ll-feedback-photos');
  if (!gallery || gallery.scrollWidth <= gallery.clientWidth + 1) return;
  galleryDrag = {gallery,id:event.pointerId,x:event.clientX,y:event.clientY,left:gallery.scrollLeft,moved:false};
 }, true);
 document.addEventListener('pointermove', event => {
  const drag = galleryDrag;
  if (!drag || drag.id !== event.pointerId) return;
  const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
  if (!drag.moved && (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy))) return;
  if (!drag.moved) drag.gallery.setPointerCapture(event.pointerId);
  drag.moved = true;
  drag.gallery.classList.add('is-dragging');
  drag.gallery.scrollLeft = drag.left - dx;
  event.preventDefault();
  event.stopPropagation();
 }, true);
 const finishGallery = event => {
  if (!galleryDrag || galleryDrag.id !== event.pointerId) return;
  const {gallery,moved} = galleryDrag;
  galleryDrag = null;
  gallery.suppressClick = moved;
  gallery.classList.remove('is-dragging');
  window.setTimeout(() => { gallery.suppressClick = false; }, 0);
 };
 document.addEventListener('pointerup', finishGallery, true);
 document.addEventListener('pointercancel', finishGallery, true);
 document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-ll-review-media]');
  const gallery = trigger?.closest('.ll-review-photo-grid,.ll-feedback-photos');
  if (!trigger || trigger.closest('ll-review-list')?.suppressClick || gallery?.suppressClick) return;
  let url;
  try {
   url = new URL(trigger.dataset.llReviewMedia, location.href);
   if (url.protocol !== 'https:' || url.username || url.password) return;
  } catch { return; }
  const kind = trigger.dataset.llReviewKind;
  if (kind !== 'image' && kind !== 'video') return;
  event.preventDefault();
  event.stopPropagation();
  if (!dialog) create();
  clear();
  origin = trigger;
  const media = document.createElement(kind === 'video' ? 'video' : 'img');
  if (kind === 'video') {
   media.controls = true;
   media.autoplay = true;
   media.playsInline = true;
   media.preload = 'metadata';
   media.setAttribute('aria-label', trigger.dataset.llReviewAlt || trigger.getAttribute('aria-label') || labels.title);
   body.append(media);
  } else {
   media.alt = trigger.dataset.llReviewAlt || trigger.querySelector('img')?.alt || labels.title;
   media.decoding = 'async';
   media.draggable = false;
   const hint = trigger.dataset.llReviewZoomHint || trigger.closest('[data-review-zoom-hint]')?.dataset.reviewZoomHint || document.querySelector('[data-review-zoom-hint]')?.dataset.reviewZoomHint || 'Tap or press Enter to zoom. Pinch or use the mouse wheel to adjust zoom. Use arrow keys to pan; press 0 to reset.';
   const rawRotation = Number(trigger.dataset.llReviewRotation || 0);
   const rotation = [0,90,180,270].includes(rawRotation) ? rawRotation : 0;
   body.append(imageFrame(media, hint, rotation));
  }
  const original=url.href;
  if(kind==='image'){
   if(/^rewimg-eu(?:-2)?\.kwcdn\.com$/.test(url.hostname)&&!/^\?imageMogr2\/rotate\/(?:90|180|270)$/.test(url.search))url.search='';
   if(/^(?:m\.media-amazon\.com|images-na\.ssl-images-amazon\.com)$/.test(url.hostname))url.pathname=url.pathname.replace(/\._(?:S[XYL]\d+|AC_[A-Z0-9_,]+)_\./,'.');
   if(url.href!==original)media.addEventListener('error',()=>{media.src=original;},{once:true});
  }
  media.src=url.href;
  dialog.showModal();
  if(kind==='video')media.play()?.catch(()=>{});
  closer.focus({preventScroll:true});
 }, true);
})();
